import React from "react";
import "./Css/Schemes.css";
import sc1 from "./Images/sc1.png";
import sc2 from "./Images/sc2.png";
import sc3 from "./Images/sc3.png";
import sc4 from "./Images/sc4.png";

export default function Schemes() {
  const schemes = [
    {
      img: sc1,
      title: "प्रधानमंत्री आवास योजना",
      desc: "ग्रामीण भागातील सर्वांसाठी एक घर उपलब्ध करण्याचे उद्देश्य असलेली ही योजना राबवली जाते. घर बांधकामावर सबसिडी चुकीने अधिक उपलब्ध दिली जाते.",
    },
    {
      img: sc2,
      title: "जल जीवन मिशन",
      desc: "प्रत्येक घरात नळाद्वारे स्वच्छ पाणी पोहोचवण्याचे आणि स्वास्थ्याची पातळी सुधारण्याचे उद्दिष्ट असलेली केंद्र सरकारची महत्त्वाकांक्षी योजना.",
    },
    {
      img: sc3,
      title: "स्वच्छ भारत अभियान",
      desc: "भारतामध्ये स्वच्छता, कचरा व्यवस्थापन आणि स्वच्छ व निरोगी जीवनासाठी राबविण्यात आलेले महत्त्वपूर्ण अभियान.",
    },
    {
      img: sc4,
      title: "प्रधानमंत्री ग्राम सडक योजना (PMGSY)",
      desc: "ग्रामीण भागांना जोडणारी ही योजना 2000 साली सुरू झाली. रस्ते सुविधा निर्माण करून ग्रामीण विकासाला गती मिळवून देणे हे मुख्य उद्दिष्ट.",
    },
  ];

  return (
    <div className="schemes-wrapper">
      <h1 className="titlesc">सरकारी योजना</h1>
      <p className="subtitlesc">
        सर्वांगीण विकास – प्रत्येक क्षेत्रात प्रगती घडवणाऱ्या योजना.

      </p>
      <p className="para">केंद्र व राज्य सरकारांकडून नागरिकांसाठी विविध योजनांची माहिती एकाच ठिकाणी.</p>

      <div className="schemes-container">
        {schemes.map((s, i) => (
          <div className="scheme-card" key={i}>
            <img src={s.img} alt={s.title} className="scheme-icon" />
            <h2>{s.title}</h2>
            <p>{s.desc}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
